(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog-contextual/assets/javascripts/contextual-dialog.js') >= 0) return;  svs.modules.push('/components/components/dialog-contextual/assets/javascripts/contextual-dialog.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


(function (svs, $, TweenLite, TimelineLite, Popper) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  var DialogContextual = function (_svs$components$dialo) {
    _inherits(DialogContextual, _svs$components$dialo);

    var _super = _createSuper(DialogContextual);

    function DialogContextual(options) {
      var _this;

      _classCallCheck(this, DialogContextual);

      options.icon = options.icon || false;
      options.area = options.area || svs.components.dialog.area.CONTEXTUAL;
      _this = _super.call(this, options);
      _this.log = new svs.core.log.Logger('DialogContextual');
      _this.zIndex = _this.options.zIndex || 140;
      return _this;
    }

    _createClass(DialogContextual, [{
      key: "render",
      value: function render() {
        _get(_getPrototypeOf(DialogContextual.prototype), "render", this).call(this);

        this._arrowEl = document.createElement('div');
        this._arrowEl.className += 'arrow';
        this.el.appendChild(this._arrowEl);
        this.addPopper();
      }
    }, {
      key: "addPopper",
      value: function addPopper() {
        new Popper(this.options.attachTo, this.el, {
          placement: 'bottom',
          positionFixed: true,
          modifiers: {
            arrow: {
              enabled: true,
              element: this._arrowEl
            },
            computeStyle: {
              gpuAcceleration: false
            },
            preventOverflow: {
              boundariesElement: 'window',
              padding: 12
            }
          }
        });
      }
    }, {
      key: "setupAnimations",
      value: function setupAnimations() {
        var _this2 = this;

        this.tl = new TimelineLite({
          paused: true,
          onComplete: function onComplete() {
            _this2.hasRevealed();
          },
          onReverseComplete: function onReverseComplete() {
            _this2.hasClosed();
          }
        });
        this.tl.add(TweenLite.fromTo(this.el, 0.2, {
          scale: 0.8,
          opacity: 0
        }, {
          scale: 1,
          opacity: 1
        }));
        this.tl.add(TweenLite.fromTo(this.el, 0.2, {
          boxShadow: '0'
        }, {
          boxShadow: '0 0 48px 4px rgba(0, 0, 0, .5)'
        }), '-=.1');
        this.tl.add(new TweenLite.fromTo(this._content, 0.2, {
          autoAlpha: 0
        }, {
          autoAlpha: 1
        }));
        this.tl.add(new TweenLite.fromTo(this._buttons, 0.2, {
          opacity: 0,
          y: 50
        }, {
          opacity: 1,
          y: 0
        }), '-=.1');
      }
    }]);

    return DialogContextual;
  }(svs.components.dialog.Confirm);

  svs.components.dialog.Contextual = DialogContextual;
})(svs, $, TweenLite, TimelineLite, Popper);
 })(window);